import type { Locale } from '@brig/api-types';

/**
 * The playable nations. Adding one is a single entry here plus its flag in
 * `flags/<id>.svg` (viewBox in flag proportions, hoist on the left); names are translated
 * right here, so nothing else needs to change.
 */
export interface Nation {
  /** Stable id, stored with games and user preferences. Lowercase letters and `_` only. */
  readonly id: string;
  /** Position in pickers, ascending. */
  readonly order: number;
  readonly names: Readonly<Record<Locale, string>>;
  /** UI accents, muted to sit with the hand-tinted chart palette. */
  readonly accent: { readonly primary: string; readonly secondary: string };
  /** A flag drawn by code instead of `flags/<id>.svg`. */
  readonly flag?: { readonly kind: 'stars-and-stripes'; readonly stars: number };
}

export const NATIONS: readonly Nation[] = [
  {
    id: 'spain',
    order: 10,
    names: { en: 'Spain', uk: 'Іспанія', ru: 'Испания' },
    accent: { primary: '#A6262C', secondary: '#D9A521' },
  },
  {
    id: 'france',
    order: 20,
    names: { en: 'France', uk: 'Франція', ru: 'Франция' },
    accent: { primary: '#2B3F7A', secondary: '#B4302C' },
  },
  {
    id: 'usa',
    order: 30,
    names: { en: 'United States', uk: 'Сполучені Штати', ru: 'Соединённые Штаты' },
    accent: { primary: '#2E3466', secondary: '#A8323A' },
    // 34 stars: the flag of 1861.
    flag: { kind: 'stars-and-stripes', stars: 34 },
  },
  {
    id: 'turkey',
    order: 40,
    names: { en: 'Ottoman Empire', uk: 'Османська імперія', ru: 'Османская империя' },
    accent: { primary: '#B3262E', secondary: '#E8D7AA' },
  },
];
